import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MemberComponent } from './member/member.component';
import { SupplierComponent } from './supplier/supplier.component';

export const routes: Routes = [
  {
    path: 'MemberOnboarding',
    data: { breadcrumb: 'BREADCRUMB.MEMBER' },
    component: MemberComponent
  },
  {
    path: 'SupplierOnboarding',
    data: { breadcrumb: 'BREADCRUMB.SUPPLIER' },
    component: SupplierComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OnboardingRoutingModule {}
